import React, { FC, useEffect } from 'react';
import { handleMSALLogout } from '../util-helpers/msal';

const MsalLogout: FC = () => {
  useEffect(() => {
    handleMSALLogout();
  }, []);

  return <div>Microsoft authentication logout in progress...</div>;
};

export default MsalLogout;
